import { useEffect, useState } from 'react'
import { ConfigProvider } from 'antd'
import { themeComponentCreator } from './ComponentThemeGenerator'
import { customThemeGenerator } from './CustomTheme'
import App from './App'
import {
  DARK_MODE,
  WHITE_COLOR,
  GUNMETAL_COLOR,
  BLACK_COLOR,
  BRIGHT_GREY_COLOR,
  GRAY_COLOR,
  MEDIUM_GRAY_COLOR,
  COMET_COLOR,
  BLUE_STROKE_BORDER,
  DUST_RED_COLOR,
  BRIGHT_RED_COLOR,
} from './constants'
import { useThemeContext } from './context/theme_context'

export const AntConfigProvider = ({ children }) => {
  const { mode, algorithm } = useThemeContext()

  return (
    <ConfigProvider
      theme={{
        algorithm: algorithm,
        components: { ...themeComponentCreator(mode) },
        token: {
          fontFamily: 'Montserrat',
          colorBgLayout: mode == DARK_MODE ? GUNMETAL_COLOR : BRIGHT_GREY_COLOR,
          colorLink: mode == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
          colorLinkHover: mode == DARK_MODE ? MEDIUM_GRAY_COLOR : GRAY_COLOR,

          colorPrimaryBorder: BLUE_STROKE_BORDER,
          colorBorder: BLUE_STROKE_BORDER,
          colorSplit: BLUE_STROKE_BORDER,

          fontSize: 14,
          padding: 16,
          fontSizeHeading1: 14,
          fontSizeHeading2: 14,
          fontSizeHeading3: 14,
          fontSizeHeading4: 14,
          fontSizeHeading5: 14,

          colorError: mode == DARK_MODE ? DUST_RED_COLOR : BRIGHT_RED_COLOR,
          colorErrorBorder:
            mode == DARK_MODE ? DUST_RED_COLOR : BRIGHT_RED_COLOR,

          colorWarning: mode == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

const logImportedStyles = (styleName) => {
  const styles = getComputedStyle(document.documentElement)

  Array.from(styles)
    .filter((name) => name.startsWith('--'))
    .forEach((name) => {
      if (!styleName) {
        console.log(name, styles.getPropertyValue(name))
      }
      if (styleName && name === styleName) {
        console.log(name, styles.getPropertyValue(name))
        return
      }
    })
}

export default function Root() {
  const { mode } = useThemeContext()
  const [customTheme, setCustomTheme] = useState(customThemeGenerator(mode))

  useEffect(() => {
    setCustomTheme(customThemeGenerator(mode))
  }, [mode])

  useEffect(() => {
    if (!customTheme) return

    Object.keys(customTheme).forEach((key) => {
      const _key = key.startsWith('--') ? key : `--${key}`
      document.documentElement.style.setProperty(_key, customTheme[key])
    })
    // logImportedStyles('--color-border-custom')
  }, [customTheme])

  return (
    <AntConfigProvider>
      <App customTheme={customTheme} />
    </AntConfigProvider>
  )
}
